import { useQuery } from '@tanstack/react-query'

import { getHerbicides } from '@/services/get-herbicides'

export const GET_HERBICIDES_QUERY = ['herbicides']

interface UseGetHerbicidesProps {
  search: string
}

export function useGetHerbicides({ search }: UseGetHerbicidesProps) {
  const query = useQuery({
    queryKey: [...GET_HERBICIDES_QUERY, { search }],
    queryFn: ({ signal }) =>
      getHerbicides({
        signal,
        params: {
          search,
        },
      }),
    staleTime: 1000 * 60 * 5, // 5 minutes,
  })

  return query
}
